import { render } from "./SectionParenthesis.vue?vue&type=template&id=7faa8fea&scoped=true"
import script from "./SectionParenthesis.vue?vue&type=script&lang=js"
export * from "./SectionParenthesis.vue?vue&type=script&lang=js"

import "./SectionParenthesis.vue?vue&type=style&index=0&id=7faa8fea&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7faa8fea"]])

export default __exports__